/*
Rags, Tack Cloth, Cheesecloth
*/
import filters from '@/modules/standardItems/schemas/finish/filters'
import headers from '@/modules/standardItems/schemas/finish/headers'
import form from '@/modules/standardItems/schemas/finish/form'

const name = 'Rags, Tack Cloth, Cheesecloth'
const id = 'QJnx3Z1aZFJigwWqfYRo'

export default {
  name,
  id,
  filters,
  headers,
  form
}
